module.exports = __webpack_public_path__ + "static/media/coaster2.8cacfa70.png";